<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Charge to Department</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="department-charge-account-payment-modal">
    <div class="ion-padding">
      <p>Business Line</p>
      <ion-select placeholder="Select a Business Line"
                  [ngModel]="''"
                  (ionChange)="onSelectBusinessLine($event)">
        <ion-select-option [value]="''">All</ion-select-option>

        <ion-select-option *ngFor="let item of businessLines"
                           [value]="item">{{item.name}}</ion-select-option>
      </ion-select>
    </div>
    <div class="ion-padding">
      <p>Department</p>
      <ng-select [minTermLength]="minLengthTerm"
                 [loading]="departmentLoading"
                 typeToSearchText="A minimum of {{minLengthTerm}} characters are required to search."
                 [typeahead]="searchKey$"
                 [(ngModel)]="selectedDepartment">
        <ng-option *ngFor="let item of departments$ | async"
                   [value]="item">{{item.name}} ({{item.code}})</ng-option>
      </ng-select>
    </div>
    <div *ngIf="selectedDepartment">
      <p class="ion-padding-horizontal">Charge Account</p>
      <ion-list class="ion-no-padding">
        <ion-item *ngFor="let item of selectedDepartment.charge_accounts">
          <ion-label>{{item.name}}</ion-label>
          <ion-button mode="md"
                      color="dark"
                      (click)="onSelectChargeAccount(item)">
            SELECT
          </ion-button>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>